import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  id?: string;
}
export function Section({
  children,
  className = '',
  delay = 0,
  id
}: SectionProps) {
  return <motion.div id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut',
    delay
  }} className={`max-w-2xl mx-auto px-6 py-16 md:py-24 ${className}`} data-id="element-190">
      {children}
    </motion.div>;
}